module.exports = __webpack_public_path__ + "img/CB53.30265b36.png";